import { WaybillIdView } from '../../../models';
import { ListRange, SearchCriteriaBase } from '../../../../common/models';
import { HazardIdentificationCodeEnum } from '../../../models/hazard-identification-code';

export interface ShipmentWaybillGoodsItemModel {
  packageTypeDescriptionCode: string;
  packageQuantity: number;
  hasDangerousGoods: boolean;
  hazardIdentificationCode: HazardIdentificationCodeEnum;
  grossWeight: number;
  grossLength: number;
  grossWidth: number;
  grossHeight: number;
  volume: number;
  huIds: string[];
  partNumbers: string[];
}

export class ShipmentWaybillGoodsItemListSearchCriteria extends SearchCriteriaBase {
  waybillIdView: WaybillIdView;
  constructor(params?: Partial<ShipmentWaybillGoodsItemListSearchCriteria> | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
